module.exports = __webpack_public_path__ + "img/Led_Green.87f247bf.png";